import { createSlice } from '@reduxjs/toolkit';
import { ITimesheet } from '../../../../dto';
import { setTimesheet } from '../actions';
import { MN_TIMESHEET, TYPE_ELEMENT } from '../../../../common';

export interface TimesheetState {
  data: ITimesheet | null;
  loading: boolean;
  error: string | null;
}

const initialState: TimesheetState = {
  data: null,
  loading: false,
  error: null,
};

export const timesheetSlice = createSlice({
  name: `${MN_TIMESHEET}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTimesheet, (state, { payload }) => {
      state.data = payload;
    });
  },
});
